import React from "react"
import { graphql, Link } from 'gatsby'
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer' 
import Seo from '../components/seo'
import { MailChimpSignup } from '../components/mailchimp-signup'
import { Footer } from '../components/footer'
import { Header } from '../components/header'
import logoWhite from '../../static/images/evitat-logo-white.png'
import "../styles/index.scss"
import { getDaysDifference } from '../services/time-diff';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faFacebook, faLinkedin, faTwitter} from '@fortawesome/free-brands-svg-icons';
export const query = graphql`
    query($slug: String!) {
        contentfulBlogPost(slug: {eq: $slug}) {
            title
            publishedDate
            slug
            author {
                authorName
                profilePicture {
                    description
                    file {
                        url
                    }
                }
            }
            backgroundImage {
                file {
                    url
                    fileName
                }
            }
            blurb {
                blurb
              }
            body {
                raw
                references {
                    contentful_id
                    file {
                        url
                        fileName
                        contentType
                    }
                    title
                    description
                }
              }
        }
        site {
            siteMetadata {
                title
                description
                author
                siteUrl
            }
        }
    }
`

let references: {
    contentful_id: string; 
    file: {url: string; contentType: string; fileName: string;}
    title: string;
    description: string;}[] = [];
// const Bold = ({ children }) => <span className="bold">{children}</span>
// const Text = ({ children }) => <p className="align-center">{children}</p>
const options = {    
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
        const source = references.find(i => i.contentful_id === node.data.target.sys?.id);
        const fileType = ['image', 'video', 'audio'].find(i => source.file.contentType.includes(i));
        switch (fileType) {
            case "image":
                return <img src={source.file.url} alt={source.description} />;
            case "video": 
                return (
                    <video width="100%" height="240" controls>
                        <source src={source.file.url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                );
            case "audio": 
                return <audio src={source.file.url} controls />;
        
            default:
                return <h5>Missing asset</h5>
        }},
    },
}

const BlogPost = ({data}) => {
    const post = data.contentfulBlogPost;
    references = post?.body?.references;
    const site = data.site;
    const fbUrlToShare = `http://www.facebook.com/share.php?u=${site.siteMetadata.siteUrl}/${post.slug}&title=${post.title}`;
    const twitterUrlToShare = `http://twitter.com/intent/tweet?url=${site.siteMetadata.siteUrl}/${post.slug}`;
    const linkedInUrlToShare = `http://www.linkedin.com/shareArticle?mini=true&url=${site.siteMetadata.siteUrl}/${post.slug}`;
    
    return (
        <div>
            <Seo 
                title={post.title} 
                slug={post.slug} 
                description={post.blurb?.blurb} 
                socialMediaShareImg={post.backgroundImage?.file?.url}
                isPost/>
            <Header type="blog"/>
            <main>
                <section className="blog">
                    <div className="blog__hero">
                        <div className="blog__hero--header" style={
                            {
                                backgroundImage: `url(${post.backgroundImage?.file?.url})`,
                            }
                            }>
                            <div className="blog__hero--title">
                                <h1> {post.title} </h1>
                            </div>
                        </div>
                    </div>
                    <div className="blog__container">
                    <div className="blog__content">
                        <div className="blog__description">
                            { documentToReactComponents(JSON.parse(post.body.raw), options) }
                        </div>
                    </div>
                    <div className="blog__authorDetails">
                        <img src={post.author?.profilePicture?.file?.url} alt="author" /> 
                        <span>{post.author?.authorName} </span>
                        <time> | {getDaysDifference(post?.publishedDate)}</time>
                    </div>
                    <div className="blog__subscribe">
                        <div className="blog__subscribe-container">
                            <h2>Stay Connected</h2>
                            <MailChimpSignup />
                            <p>Subscribe to our exclusive mailing list and get the freshest stories from the evitat team</p>
                            <div className="section-about__socialMedia">
                                <ul>
                                    <li><a href={fbUrlToShare} className="fa"><FontAwesomeIcon icon={faFacebook} /></a></li>
                                    <li><a href={twitterUrlToShare} className="fa"><FontAwesomeIcon icon={faTwitter} /></a></li>
                                    <li><a href={linkedInUrlToShare} className="fa"><FontAwesomeIcon icon={faLinkedin} /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    </div>
                </section>
            </main>
            <Footer/>
        </div>
    )
}


export default BlogPost